import { SeparatorProps } from './Separator.types'
import { StyledSeparator } from './Separator.styles'

export const Separator = (props: SeparatorProps) => {
  return <StyledSeparator {...props} />
}
